<template>
  <div class="orderDetail">
    <el-form
      ref="orderDetailForm"
      status-icon
      label-position="left"
      :inline="true"
      :model="orderDetailForm"
      class="demo-form-inline"
      :rules="orderDetailRules"
    >
      <el-form-item label="主订单号">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.main_number"
          placeholder="主订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="推送时间">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.created_at"
          placeholder="推送时间"
        ></el-input>
      </el-form-item>
      <el-form-item label="要求发货日">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.out_ware_day"
          placeholder="要求发货日"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="订单日期">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.created_at"
          placeholder="订单日期"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="客户">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.user_name"
          placeholder="客户"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户电话" v-if="isFactory">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.mobile"
          placeholder="客户电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户地址" v-if="isFactory">
        <el-input
          type="textarea"
          style="font-size:12px;"
          :disabled="true"
          v-model="orderDetailForm.address"
          placeholder="客户地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          :disabled="true"
          v-model="orderDetailForm.mo_status"
          placeholder="状态"
        >
          <el-option
            v-for="item in od_statusList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订货总数量">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.totalAmount"
          placeholder="订货总数量"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="客户地址">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.address"
          placeholder="客户地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户联系方式">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.mobile"
          placeholder="客户联系方式"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="打包箱数"
        required
        prop="box_num"
      >
        <el-input
          v-model="orderDetailForm.box_num"
          :disabled="$route.query.operate==='look'"
          placeholder="打包箱数"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="总称重"
        required
        prop="weight"
      >
        <el-input
          v-model="orderDetailForm.weight"
          :disabled="$route.query.operate==='look'"
          placeholder="总称重(kg)"
        ></el-input>
      </el-form-item>
      <el-form-item label="已打印次数">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.print_num"
          placeholder="已打印次数"
        ></el-input>
      </el-form-item>
      <el-form-item label="实到箱数">
        <el-input
          :disabled="true"
          v-model="orderDetailForm.receipt_box"
          placeholder="实到箱数"
        ></el-input>
      </el-form-item> -->
    </el-form>
    <p class="goodsInfo">商品信息</p>
    <order-detail-table v-loading="loadingDetail" @updateOrder="getOrderDetail" :orderDetailTableData="orderDetailTableData"></order-detail-table>
    <!-- <div class="savebtn">
      <el-button
        type="primary"
        @click="saveDetail"
        v-show="$route.query.operate!=='look'"
        size="small"
      >保存</el-button>
    </div> -->
  </div>
</template>
<script>
import { getOdStatusList } from '@/utils/utils'
import orderDetailTable from '@/components/bigorder/order-detail-table.vue'
import { getOrderDetail, updatePack, getWrongOrder } from '@/models/orderModel'
export default {
  components: { orderDetailTable },
  data () {
    var checkBoxNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        if (!(/(^[1-9]\d*$)/.test(value))) {
          callback(new Error('请输入正整数'))
        } else {
          if (parseInt(value) < 0) {
            callback(new Error('必须大于0'))
          } else {
            callback()
          }
        }
      }, 300)
    }
    var checkWeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        if (!((/^\d+(\.\d+)?$/.test(value)))) {
          callback(new Error('请输入正数'))
        } else {
          if (parseInt(value) < 0) {
            callback(new Error('必须大于0'))
          } else {
            callback()
          }
        }
      }, 300)
    }
    return {
      orderDetailForm: {
        id: '',
        main_number: '',
        created_at: '',
        mo_status: '',
        user_name: '',
        address: '',
        mobile: '',
        box_num: '',
        weight: '',
        print_num: '',
        receipt_box: '',
        totalAmount: 0,
        out_ware_day: ''
      },
      od_statusList: [],
      orderDetailRules: {
        box_num: [
          { validator: checkBoxNum, trigger: 'blur' }
        ],
        weight: [
          { validator: checkWeight, trigger: 'blur' }
        ]
      },
      orderDetailTableData: [],
      loadingDetail: true,
      isFactory: true
    }
  },
  created () {
    this.getOrderDetail()
  },
  mounted () {
    this.od_statusList = getOdStatusList().mo_statusList
  },
  methods: {
    async saveDetail () {
      this.$refs.orderDetailForm.validate((valid) => {
        const saveDetail = async () => {
          let params = {
            id: this.orderDetailForm.id,
            box_num: this.orderDetailForm.box_num,
            weight: this.orderDetailForm.weight
          }
          let data = await updatePack(params)
          if (data.message === 'Success') {
            this.$message.success('保存成功')
            if(localStorage.getItem('is_jgj')==='1'){
            // 为紧固件
              this.$router.push('/bigorder/manageFastener')
            }else{
              this.$router.push('/bigorder/manage')
            }
            this.$refs.orderDetailForm.resetFields()
          }
        }
        if (valid) {
          saveDetail()
        }
      })
    },
    async getOrderDetail () {
      // let tableParams = {
      //   id: id
      // }
      this.loadingDetail = true
      if (this.$route.params.wrongDetail) {
        let params = {
          id: this.$route.params.id
        }
        let wrongDetaildata = await getWrongOrder(params)
        this.orderDetailTableData = wrongDetaildata
      } else {
        let formParams = {
          id: this.$route.query.id
        }
        // let tableData = await getOrderListDetail(tableParams)
        let formdata = await getOrderDetail(formParams)
        if (formdata && formdata.length !== 0) {
          this.orderDetailTableData = formdata
        }
      }
      this.orderDetailForm.main_number = this.orderDetailTableData[0].main_number
      this.orderDetailForm.created_at = this.orderDetailTableData[0].created_at
      this.orderDetailForm.out_ware_day = this.orderDetailTableData[0].out_ware_day
      this.orderDetailForm.user_name = this.orderDetailTableData[0].user_name
      this.orderDetailForm.mo_status = this.orderDetailTableData[0].mo_status
      this.orderDetailForm.address = this.orderDetailTableData[0].address
      this.orderDetailForm.mobile = this.orderDetailTableData[0].mobile
      for (let i of this.orderDetailTableData) {
        let data = getOdStatusList().statusList.filter(item => item.value === i.status)
        if (data.length !== 0) {
          i.mo_statusName = data[0].label
        }
        this.orderDetailForm.totalAmount = parseInt(this.orderDetailForm.totalAmount) + parseInt(i.amount)
      }
      setTimeout(() => {
        this.loadingDetail = false
      }, 300)
    }
  }
}
</script>
<style lang="scss">
.orderDetail {
  .goodsInfo {
    border-top: 1px solid #ddd;
  }
  .savebtn {
    text-align: center;
    margin-top: 10px;
  }
  .el-form-item__label {
    width: 88px;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/order-detail.vue